import React, { FC, useContext, useEffect } from 'react'

import Component from '.'
import {
  ActiveStoryContext,
  HeadingsContextProvider,
} from '@izettle/public-site-components/dist/help-center'
import { getBlokContent } from '@app/utils/blok-content'
import { isNonEmptyArray } from '@app/utils/type-check'
import { SearchOverlayWrapper } from '@app/components/search-overlay-wrapper'
import { Blok } from '@app/typings/blok'
import { supportedQueryParameters } from '@app/utils/query-parameters-utils'
import StoryInfo from './StoryInfo'

const HeadingNavigation: FC<any> = ({
  className,
  headingNavigation,
}) => {
  return (
    <div className={className}>
      {headingNavigation && (
        <Component content={{ ...headingNavigation[0] }} />
      )}
    </div>
  )
}

type Props = {
  navigation: Blok[]
  headingNavigation: Blok[]
  header: Blok[]
  statusBanner: Blok[]
  footer: Blok[]
  search: Blok[]
  title: string
  path: string
  articleFeedback: Blok[]
  articleId: string
  fullSlug: string
  badgeGroup: Blok[]
  queryParameters: supportedQueryParameters
  articleFullSlug?: string | null
}

export const LayoutArticle: FC<Props> = ({
  navigation,
  headingNavigation,
  header,
  statusBanner,
  footer = [],
  search = [],
  title,
  path = '',
  children,
  articleFeedback,
  articleId,
  fullSlug,
  queryParameters,
  badgeGroup,
  articleFullSlug,
}) => {
  const { setActiveStory } = useContext(ActiveStoryContext)

  useEffect(() => {
    setActiveStory(path)
  }, [setActiveStory, path])

  const hideFooter = queryParameters.hideFooter
  const hideRightSidebar = queryParameters.hideRightSidebar
  const hideHeader = queryParameters.hideHeader

  return (
    <div className="wrapper" style={{ minHeight: '100vh' }}>
      <SearchOverlayWrapper {...search[0]} />
      {!hideHeader && header && (
        <Component
          content={{
            ...header[0],
            articleNavigation: getBlokContent(navigation),
            initialActiveStory: path,
          }}
        />
      )}
      <main role="main" className="main">
        {articleFullSlug && <StoryInfo articleFullSlug={articleFullSlug} />}
        {isNonEmptyArray(statusBanner) && (
          <Component content={getBlokContent(statusBanner)} />
        )}
        <div className="flex-container section-normal py-extra">
          {isNonEmptyArray(navigation) && (
            <div className="sidebar-left">
              <Component
                content={{ ...navigation[0], initialActiveStory: path }}
              />
            </div>
          )}

          <HeadingsContextProvider>
            <div className="content sb-indexed__body">
              <div className="article-title-container">
                <h1>{title}</h1>
                {isNonEmptyArray(badgeGroup) && (
                  <Component content={getBlokContent(badgeGroup)} />
                )}
              </div>
              {!hideRightSidebar && (
                <HeadingNavigation
                  headingNavigation={headingNavigation}
                  className="d-lg-none d-xl-none" />
              )}
              {children}

              {isNonEmptyArray(articleFeedback) && (
                <Component
                  content={{
                    ...getBlokContent(articleFeedback),
                    path,
                    articleId,
                    fullSlug,
                  }}
                />
              )}
            </div>

            {!hideRightSidebar && (
              <HeadingNavigation
                title={title}
                headingNavigation={headingNavigation}
                className="sidebar-right" />
            )}
          </HeadingsContextProvider>
        </div>
      </main>

      {!hideFooter && (
        <div className="bottom">
          {footer &&
            footer.map((block) => (
              <Component key={block._uid} content={block} />
            ))}
        </div>
      )}
    </div>
  )
}
